module.exports = __webpack_public_path__ + "static/img/WashingtonShelf-RA.6b01387.png";